"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appleChannelTodayTabApiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
function appleChannelTodayTabApiClient(networkClient) {
    return {
        findAppleTodayTabsOptions: async (params) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/options/today-tabs`);
        },
        getAttChannel: async (params) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/today-tabs`);
        },
        listAttChannels: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/today-tabs`, query, config);
        },
        createAttChannel: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/today-tabs`, body);
        },
        updateAttChannel: async (params, body) => {
            return networkClient.putHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/today-tabs`, body);
        },
        deleteAttChannel: async (params) => {
            return networkClient.deleteHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/today-tabs`);
        },
        getAttChannelRegion: async (params) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/today-tabs/regions/${params.regionId}`);
        },
        listAttChannelRegions: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/today-tabs/regions`, query, config);
        },
        createAttChannelRegion: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/today-tabs/regions`, body);
        },
        updateAttChannelRegion: async (params, body) => {
            return networkClient.putHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/today-tabs/regions/${params.regionId}`, body);
        },
        deleteAttChannelRegion: async (params) => {
            return networkClient.deleteHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/today-tabs/regions/${params.regionId}`);
        },
        importAttCampaign: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/today-tabs/import`, body);
        },
        updateAttCampaign: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/today-tabs/update-import`, body);
        },
        syncAttChannel: async (params, body = {}) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/today-tabs/sync`, body);
        },
        listAttChannelCampaignNames: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/today-tabs/campaign-names`, query, config);
        },
        updateAttChannelCampaignNames: async (params, body) => {
            return networkClient.putHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/today-tabs/campaign-names`, body);
        },
        getAttChannelSynchronisation: async (params) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/today-tabs/synchronisation`);
        },
    };
}
exports.appleChannelTodayTabApiClient = appleChannelTodayTabApiClient;
